import { RUN_ORCHESTRARIONS_STATUS } from 'interfaces/runOrchestration/workflowRow';
import { USER_PERMISSIONS } from 'utils/common-constants';
import { hasPermission } from 'utils/commonFunctions/CommonFunctions';
import {
  IMPORT,
  CREATE_PRODUCT,
  CONFIG_RUN,
} from './runOrchestrationButtons.constants';

export const isCorrectFileType = (file: any) => {
  return file?.name?.toLowerCase().endsWith('.xml');
};

export const checkIfDisabled = (
  buttonType: string,
  selectedOrchestration: any,
  isLoading: boolean,
  userPermission: any
) => {
  let isDisabled = false;

  if (buttonType === IMPORT) {
    isDisabled =
      isLoading ||
      !hasPermission(userPermission, [USER_PERMISSIONS.ORCHESTRATION_IMPORT]);
  } else if (buttonType === CREATE_PRODUCT) {
    isDisabled =
      !selectedOrchestration ||
      isLoading ||
      selectedOrchestration.isProduct ||
      !hasPermission(userPermission, [USER_PERMISSIONS.PRODUCT_CREATE]);
  } else if (buttonType === CONFIG_RUN) {
    isDisabled =
      !selectedOrchestration ||
      selectedOrchestration.status === RUN_ORCHESTRARIONS_STATUS.INACTIVE ||
      isLoading ||
      !hasPermission(userPermission, [USER_PERMISSIONS.ORCHESTRATION_SUBMIT]);
  }
  return isDisabled;
};

export const xmlFileReader = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject('');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const xmlText = e.target?.result;
      if (typeof xmlText !== 'string') {
        reject('');
        return;
      }
      try {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, 'application/xml');
        const workflowElement = xmlDoc.getElementsByTagName('workflow')[0];
        const workflowName = workflowElement
          ? workflowElement.getAttribute('name')
          : '';
        resolve(workflowName ?? '');
        return;
      } catch (error) {
        reject('Error parsing XML');
        return;
      }
    };
    reader.onerror = () => {
      reject('');
    };
    reader.readAsText(file);
  });
};
